export default "__VITE_ASSET__d9d39559__"